export default {
    namespaced: true,
    state: {
        isSidebarCollapsed: false,
        currentCase: null,
        updateCasesList: +new Date(),
        casesTabView: 'all',
        isExportInProgress: false,
        exportCaseId: null,
        isExportHidden: false,
        isExportSuccessful: localStorage.getItem('isExportSuccessful') === 'true',
        exportCaseName: localStorage.getItem('exportCaseName'),
        exportedCaseId: localStorage.getItem('exportedCaseId'),
        exportDate: localStorage.getItem('exportDate'),
    },
    getters: {
        getSidebarState: ({isSidebarCollapsed}) => isSidebarCollapsed,
        getCurrentCase: ({currentCase}) => currentCase,
        getUpdateCasesList: ({updateCasesList}) => updateCasesList,
        getCasesTabView: ({casesTabView}) => casesTabView,
        getIsExportInProgress: ({isExportInProgress}) => isExportInProgress,
        getExportCaseId: ({exportCaseId}) => exportCaseId,
        getIsExportHidden: ({isExportHidden}) => isExportHidden,
        getIsExportSuccessful: ({isExportSuccessful}) => isExportSuccessful,
        getExportCaseName: ({exportCaseName}) => exportCaseName,
        getExportedCaseId: ({exportedCaseId}) => exportedCaseId,
        getExportDate: ({exportDate}) => exportDate,
    },
    actions: {
        setSidebarState: ({commit}, payload) => {
            commit('SET_SIDEBAR_STATE', payload);
        },
        setCurrentCase: ({commit}, payload) => {
            commit('SET_CURRENT_CASE', payload);
        },
        setUpdateCasesList: ({commit}) => {
            commit('SET_UPDATE_CASES_LIST');
        },
        setCasesTabView: ({commit}, payload) => {
            commit('SET_CASE_TAB_VIEW', payload);
        },
        startExport: ({commit}, caseId) => {
            commit('SET_EXPORT_IN_PROGRESS', true);
            commit('SET_EXPORT_CASE_ID', caseId);
        },
        hideExport: ({commit}) => {
            commit('SET_EXPORT_HIDDEN', true);
        },
        completeExport: ({commit, state}, {isSuccessful = false, caseName = null} = {}) => {
            const caseId = state.exportCaseId;
            commit('SET_EXPORT_IN_PROGRESS', false);
            commit('SET_EXPORT_CASE_ID', null);
            if (isSuccessful) {
                commit('SET_EXPORT_SUCCESSFUL', true);
                commit('SET_EXPORT_CASE_NAME', caseName);
                commit('SET_EXPORTED_CASE_ID', caseId);
                const currentDate = new Date().toISOString();
                commit('SET_EXPORT_DATE', currentDate);
            }
        },
        resetExportStatus: ({commit}) => {
            commit('SET_EXPORT_HIDDEN', false);
            commit('SET_EXPORT_SUCCESSFUL', false);
            commit('SET_EXPORT_CASE_NAME', null);
            commit('SET_EXPORTED_CASE_ID', null);
            commit('SET_EXPORT_DATE', null);
            localStorage.removeItem('isExportSuccessful');
            localStorage.removeItem('exportCaseName');
            localStorage.removeItem('exportedCaseId');
            localStorage.removeItem('exportDate');
        },
    },
    mutations: {
        SET_SIDEBAR_STATE: (state, payload) => {
            state.isSidebarCollapsed = payload;
        },
        SET_CURRENT_CASE: (state, payload) => {
            state.currentCase = payload;
        },
        SET_UPDATE_CASES_LIST: (state) => {
            state.updateCasesList += 1;
        },
        SET_CASE_TAB_VIEW: (state, payload) => {
            state.casesTabView = payload;
        },
        SET_EXPORT_IN_PROGRESS: (state, payload) => {
            state.isExportInProgress = payload;
        },
        SET_EXPORT_CASE_ID: (state, payload) => {
            state.exportCaseId = payload;
        },
        SET_EXPORT_HIDDEN: (state, payload) => {
            state.isExportHidden = payload;
        },
        SET_EXPORT_SUCCESSFUL: (state, payload) => {
            state.isExportSuccessful = payload;
            localStorage.setItem('isExportSuccessful', payload);
        },
        SET_EXPORT_CASE_NAME: (state, payload) => {
            state.exportCaseName = payload;
            if (payload) {
                localStorage.setItem('exportCaseName', payload);
            } else {
                localStorage.removeItem('exportCaseName');
            }
        },
        SET_EXPORTED_CASE_ID: (state, payload) => {
            state.exportedCaseId = payload;
            if (payload) {
                localStorage.setItem('exportedCaseId', payload);
            } else {
                localStorage.removeItem('exportedCaseId');
            }
        },
        SET_EXPORT_DATE: (state, payload) => {
            state.exportDate = payload;
            if (payload) {
                localStorage.setItem('exportDate', payload);
            } else {
                localStorage.removeItem('exportDate');
            }
        },
    }
};
